import styled from 'styled-components';

import Close from 'vectors/close.svg';
import { fade, scaleUp } from 'styles/animations';
import { media } from 'styles/utils';

export const ModalContainer = styled.div`
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 10;
  height: 100%;
`;

export const ModalBackground = styled.div`
  position: fixed;
  width: 100vw;
  height: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  background-color: ${({ theme }) => theme.colors.black.opacity};
  animation: ${fade} 200ms ease-out;
`;

export const ModalContent = styled.div`
  opacity: 0;
  transform: scale(0.4);
  position: relative;
  z-index: 3;
  width: 100%;
  max-width: 400px;
  padding: 32px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 16px;
  height: 100%;
  overflow-y: auto;
  animation: ${scaleUp} 300ms ease-out forwards;

  ${media.small`
    width: 80%;
    height: auto;
    align-self: center;
  `}
`;

export const CloseIcon = styled(Close)`
  position: fixed;
  right: 24px;
  top: 24px;
  cursor: pointer;

  ${media.small`
    position: absolute;
  `}
`;
